import img from "../assets/ombra_sera_home.jpg";

import classes from "./css/OmbreSeraHome.module.css";

const OmbreSeraHome = () => {
  return (
    <div className={classes.main}>
      <div className={classes.row_dionisiache}>
        <div className={classes.image_container}>
          <img src={img} alt="dionisiache" className={classes.image} />
        </div>

        <div className={classes.info_container}>
          <div className={classes.info_dionisiache}>
            <h2>Premio</h2>
            <h1>OMBRA DELLA SERA</h1>
            <h5>
              OMBRA DELLA SERA – all’ ORGANIZZAZIONE TEATRALE - dal prestigioso
              Festival Internazionale Teatro Romano di Volterra, PER LA SEZIONE
              DEDICATA ALL’IMPRESA TEATRALE per le sue attività e l’impegno
              relativo al Festival di SEGESTA con la seguente motivazione: “Un
              uomo di teatro a 360 gradi. Dal 2015 è direttore artistico de “Le
              Dionisiache”, festival al quale ha saputo ridare vita, dopo anni
              di regresso e chiusura, con una linea artistica capace di
              coniugare i classici col gusto della novità e della ricerca,
              grazie a un sistema di laboratori e residenze teatrali che in tre
              edizioni ha consentito a centinaia di giovani artisti di vivere
              l'atmosfera del festival e di sperimentarvi il proprio lavoro. Con
              coraggio e un impegno senza riserve , ha saputo dare al festival
              una veste rinnovata capace di mescolare tradizione e innovazione,
              portando non solo le cifre a raddoppiare in termini di presenze e
              incassi, ma anche radicando persone, eventi e spettacoli
              all'interno di un territorio: un festival, dunque, non più
              soltanto per turisti di passaggio o addetti ai lavori, ma per
              l'intera comunità di Calatafimi Segesta, che ora accoglie e vive
              l'evento come un elemento essenziale della propria identità,
              storia ed economia”.
            </h5>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OmbreSeraHome;
